import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Car, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth, formatApiError } from "@/context/AuthContext";

const DASH = { customer: "/dashboard", driver: "/driver", operator: "/driver", agent: "/agent", admin: "/admin", super_admin: "/admin", support: "/agent" };

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      navigate(DASH[u.role] || "/");
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen">
      <div className="hidden w-1/2 bg-navy lg:block relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1623189831691-601692d33879?q=85&w=1200" alt="" className="h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 flex flex-col justify-end p-12">
          <Link to="/" className="mb-auto flex items-center gap-2"><span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand text-white"><Car size={18} /></span><span className="font-heading text-lg font-bold text-white">SmartFares<span className="text-brand">4U</span></span></Link>
          <h2 className="font-heading text-3xl font-bold text-white">Your Ride. Your Fare. Your Journey.</h2>
          <p className="mt-2 text-slate-300">Book trusted taxis across the UK in seconds.</p>
        </div>
      </div>
      <div className="flex w-full items-center justify-center px-6 lg:w-1/2">
        <form onSubmit={submit} className="w-full max-w-sm">
          <Link to="/" className="mb-6 flex items-center gap-2 lg:hidden"><span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy text-white"><Car size={18} /></span><span className="font-heading text-lg font-bold text-navy">SmartFares<span className="text-brand">4U</span></span></Link>
          <h1 className="font-heading text-2xl font-bold text-navy">Welcome back</h1>
          <p className="mt-1 text-sm text-slate-500">Log in to manage your bookings.</p>
          <div className="mt-6 space-y-4">
            <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required /></div>
            <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required /></div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <Button type="submit" className="w-full bg-brand hover:bg-brand/90" disabled={loading} data-testid="login-submit">{loading ? <Loader2 size={16} className="animate-spin" /> : "Log In"}</Button>
          </div>
          <p className="mt-4 text-center text-sm text-slate-500">No account? <Link to="/register" className="font-semibold text-brand">Sign up</Link></p>
        </form>
      </div>
    </div>
  );
}
